<div class="container-fluid mt-5 pt-4" *ngIf="permissions?.keyMetrics?.access">
  <!-- Dynamic Dashboard Header -->
  <div class="row mb-4 animate__animated animate__fadeInDown px-3">
    <div class="col-12">
      <h2 class="premium-title mb-1">Key Metrics Dashboard</h2>
      <p class="text-muted">Overview of critical operational and financial metrics.</p>
    </div>
  </div>

  <div class="row align-items-stretch px-3">
    <!-- BALANCE -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.balance?.view">
      <a routerLink="balance" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-balance shadow-sm">
              <i class="fa fa-university fa-2x"></i>
            </div>
            <h5 class="metric-title">Balance</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- CLIENTS -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.clients?.view">
      <a routerLink="client-reports" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-clients shadow-sm">
              <i class="fa fa-users fa-2x"></i>
            </div>
            <h5 class="metric-title">Clients</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- RECEIVABLES -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.receivables?.view">
      <a routerLink="receivables" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-receivables shadow-sm">
              <i class="fa fa-money fa-2x"></i>
            </div>
            <h5 class="metric-title">Receivables</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- DISCOUNTS -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.discounts?.view">
      <a routerLink="discounts" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-discounts shadow-sm">
              <i class="fa fa-tags fa-2x"></i>
            </div>
            <h5 class="metric-title">Discounts</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- EXPENSES -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.expenses?.view">
      <a routerLink="expenses" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-expenses shadow-sm">
              <i class="fa fa-credit-card fa-2x"></i>
            </div>
            <h5 class="metric-title">Expenses</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- PERFORMANCE -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.performance?.view">
      <a routerLink="performance" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-performance shadow-sm">
              <i class="fa fa-line-chart fa-2x"></i>
            </div>
            <h5 class="metric-title">Performance</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- STAFF COLLECTIONS -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.staffCollections?.view">
      <a routerLink="staff-collection" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-staff shadow-sm">
              <i class="fa fa-briefcase fa-2x"></i>
            </div>
            <h5 class="metric-title">Staff Collection</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- TAT -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.tat?.view">
      <a routerLink="tat" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-tat shadow-sm">
              <i class="fa fa-clock-o fa-2x"></i>
            </div>
            <h5 class="metric-title">TAT</h5>
          </div>
        </div>
      </a>
    </div>

    <!-- CASES -->
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" *ngIf="permissions?.staffCollections?.view">
      <a routerLink="cases" class="metric-link">
        <div class="metric-card glass-card">
          <div class="metric-card-body">
            <div class="metric-icon-wrapper icon-cases shadow-sm">
              <i class="fa fa-folder-open fa-2x"></i>
            </div>
            <h5 class="metric-title">Cases</h5>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
